import React, { useEffect, useState } from "react";
import { getReferralDetails } from "../home/cl_LoyalltyCoins";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import wallet from "../../assets/images/loyalty/wallet.svg";
import frnsignup from "../../assets/images/loyalty/friend-signup.svg";
import PaginationComponent from "../common/PaginationComponent";
import { getUserLoyalty } from "../signIn/cl_SignInSlice";

const CoinsItem = ({ label, value, icon, alt }) => (
  <div className="SB-coinsItem">
    <div className="SB-coinsItem-label">{label}</div>
    <div className="SB-coinsItem-value">
      <img src={icon} alt={alt} />
      <span>{value}</span>
    </div>
  </div>
);

const ReferalBonus = ({ showTable }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const token = getFromLocalStorage("gk");
  const { referralDetails, loader } = useSelector(
    (state) => state?.coinsHistory
  );
  const { errorMessage } = useSelector((state) => state?.signUp);
  let PageSize = 10;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getReferralDetails(token));
  }, []);
  const [totalSignups, setTotalSignups] = useState(0);
  const [totalCash, setTotalCash] = useState(0);
  useEffect(() => {
    if (referralDetails.length > 0) {
      // Assuming totalSignups is the same for all records, we can take it from the first item
      setTotalSignups(referralDetails[0].totalSignups);
      setTotalCash(referralDetails[0].totalReferralAmountEarned);
    }
  }, [referralDetails]);
  const { userLoyalty, userDetails } = useSelector((state) => state?.signIn);
  const filterLevelData = userLoyalty?.loyaltyLevelDuration?.filter(
    (item) => item.loyalty_level !== "level4"
  );
  const coinsData = [
    {
      label: "Fasfas Bonus",
      value: totalCash,
      icon: wallet,
      alt: "wallet",
    },
    {
      label: "Friends signed up",
      value: totalSignups,
      icon: frnsignup,
      alt: "friend-signup",
    },
  ];
  useEffect(() => {
    if (userDetails?.userId) {
      dispatch(getUserLoyalty(userDetails?.userId));
    }
  }, [userDetails?.userId]);
  return (
    <div className="SB-myAccount-sectionBox SB-referralBonus">
      {showTable === "yes" && (
        <div className="SB-myAccount-sectionBox_header SB-title">
          Referral Bonus
        </div>
      )}
      <div className="SB-myAccount-sectionBox SB-referAndEarn-earning">
        <div className="SB-myAccount-sectionBox_header">
          Lifetime Earning from Refer &amp; Earn
        </div>
        <div className="SB-myAccount-sectionBox_content">
          <div className="SB-coinsItem-group">
            {coinsData.map((coin, index) => (
              <CoinsItem key={index} {...coin} />
            ))}
          </div>
        </div>
        {referralDetails?.length >= 1 && (
          <>
            {/* {
          showTable === "yes" && */}
            <div className="SB-userLevel-table SB-allearnings-table SB-table-scrollable">
              <table>
                <colgroup>
                  <col />
                  <col />
                  <col />
                  <col className="active" />
                </colgroup>
                <thead>
                  <tr>
                    <td>Mobile Number</td>
                    <td>Date of Signup</td>
                    <td>Referral Amount Earned</td>
                    <td>My Loyalty Level</td>
                  </tr>
                </thead>
                <tbody>
                  {!loader &&
                    referralDetails?.length >= 1 &&
                    referralDetails.map(
                      (referral, index) => {
                        return (
                          <tr key={index}>
                            {filterLevelData?.map((level, index) => {
                              const signupDate = new Date(referral.signupDate);
                              const startDate = new Date(level.start_date);
                              const endDate = level.end_date
                                ? new Date(level.end_date)
                                : new Date();

                              if (
                                signupDate >= startDate &&
                                signupDate <= endDate
                              ) {
                                return (
                                  <>
                                    <td>{referral?.referredUserName}</td>
                                    <td>
                                      {referral?.signupDate.split("T")[0]}
                                    </td>
                                    <td>{referral?.referralAmountEarned}</td>
                                    <td>
                                      <div key={index}>
                                        {level.loyalty_level === "level0" && (
                                          <img
                                            src={require("../../assets/images/loyalty/dash.webp")}
                                            alt="dash"
                                            className="myLoyalty-image"
                                          />
                                        )}
                                        {level.loyalty_level === "level1" && (
                                          <img
                                            src={require("../../assets/images/loyalty/sprint.webp")}
                                            alt="sprint"
                                            className="myLoyalty-image"
                                          />
                                        )}
                                        {level.loyalty_level === "level2" && (
                                          <img
                                            src={require("../../assets/images/loyalty/surge.webp")}
                                            alt="surge"
                                            className="myLoyalty-image"
                                          />
                                        )}
                                        {level.loyalty_level === "level3" && (
                                          <img
                                            src={require("../../assets/images/loyalty/thrill.webp")}
                                            alt="thrill"
                                            className="myLoyalty-image"
                                          />
                                        )}
                                      </div>
                                    </td>
                                  </>
                                );
                              }
                              return null;
                            })}{" "}
                          </tr>
                        );
                      }

                      // <ReferralRow key={index} {...referral} />
                    )}
                </tbody>
              </table>
            </div>

            {/* // } */}
            {loader ? (
              <div className="SB-section-loader">
                <div className="SB-section-loader-container">
                  <span className="SB-dot"></span>
                  <span className="SB-dot"></span>
                  <span className="SB-dot"></span>
                  <span className="SB-dot"></span>
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        )}
        {/* {errorMessage && (
          <div className="SB-msgBox">
            <div className="SB-msgBox-container">
              Currently there is no data available
            </div>
          </div>
        )} */}
        {/* {!loader && (
          <PaginationComponent
            currentPage={currentPage}
            totalCount={referralDetails?.totalRecords || 0}
            pageSize={PageSize}
            onPageChange={(page) => setCurrentPage(page)}
            setCurrentPage={setCurrentPage}
          />
        )} */}
      </div>
    </div>
  );
};

export default ReferalBonus;
